/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { DtpContentContainer } from 'dtp-react-components';
import NovoRelatorioConflitoPeriodos from './NovoRelatorioConflitoPeriodos';
import {
  buscaDestinatarios,
  doPost,
  doGet,
} from '../../utils/requests';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';
import * as listUtils from '../../utils/listsSelect';
import User from '../../domain/User';
import FiltroRelatorioConflitoPeriodos from './FiltroRelatorioConflitoPeriodos';
import { Button } from '../../components';

class TelaRelatorioConflitoPeriodos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaResultados: [],
      listaResultadosFormatados: [],
      colunasRelatorio: [],
      nomeRelatorio: '',
      dataFormatOptions: {},
      papelUsuarioLogado: null,
      nomeSolicitante: '',
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosAtuais: {},
      filtrosEscolhidos: {},
      urlExportacao: null,
      parametrosExportacao: null,
    };
  }

  componentDidMount() {
    sessionStorage.removeItem('filtroRelatorioAnalitico');
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    this.definePapelFiltro();
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {};
    if (atributosPesquisa.participanteObservador) {
      atributos = { ...atributos, participanteObservador: atributosPesquisa.participanteObservador };
    }
    if (atributosPesquisa.participante) {
      atributos = { ...atributos, participante: atributosPesquisa.participante };
    }
    if (atributosPesquisa.estado) {
      atributos = { ...atributos, estado: atributosPesquisa.estado };
    }
    if (atributosPesquisa.opcao) {
      atributos = { ...atributos, opcao: atributosPesquisa.opcao };
    }
    if (atributosPesquisa.motivo) {
      atributos = { ...atributos, motivo: atributosPesquisa.motivo };
    }
    if (atributosPesquisa.superintendencia) {
      atributos = { ...atributos, superintendencia: atributosPesquisa.superintendencia };
    }
    if (atributosPesquisa.gex) {
      atributos = { ...atributos, gex: atributosPesquisa.gex };
    }
    if (atributosPesquisa.aps) {
      atributos = { ...atributos, aps: atributosPesquisa.aps };
    }
    if (atributosPesquisa.estadoConflito) {
      atributos = { ...atributos, estadoConflito: atributosPesquisa.estadoConflito };
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  // SE AS OPÇOES SOLICITANTE OU DESTINATARIO
  // ESTIVEREM SELECIONADAS, TRATA-SE DE UMA
  // CONSULTA POR VISÃO.
  realizaConsulta = (valoresFiltro) => {
    let filtrosEscolhidos = {};
    if (valoresFiltro) {
      filtrosEscolhidos = this.montaFiltros(valoresFiltro);
    }

    this.setState({ ...this.state, filtrosEscolhidos, filtrosAtuais: valoresFiltro }, () => this.executaConsulta());
  }

  zerarPaginacao = () => {
    this.preparaNovaConsulta();
  }

  definePapelFiltro = () => {
    let retorno = '';
    const isRgps = this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'consultar-compensacao-rgps']);
    const isRpps = this.props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']);
    const isAnalistaSprev = this.props.auth.checkPermission(['analisar-negocio-sprev']);
    const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);
    const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);
    const isAuditorComprev = this.props.auth.checkPermission(['auditar-comprev']);

    if (isRgps) {
      retorno = 'analista-rgps';
    }
    if (isRpps) {
      retorno = 'analista-rpps';
    }
    if (isAnalistaSprev) {
      retorno = 'analista-sprev';
    }
    if (isAnalistaDtp) {
      retorno = 'analista-dtp';
    }
    if (isAnalistaDcomp) {
      retorno = 'analista-rgps';
    }
    if (isAuditorComprev) {
      retorno = 'auditor-comprev';
    }

    this.setState({
      papelUsuarioLogado: retorno,
    }, () => this.buscarParticipantePeloCnpjLogado());
  }

  defineNivelFiltro = () => {
    if (this.state.filtrosEscolhidos.participante) {
      return 4;
    } else if (this.state.filtrosEscolhidos.aps) {
      return 3;
    } else if (this.state.filtrosEscolhidos.gex) {
      return 2;
    } else if (this.state.filtrosEscolhidos.superintendencia) {
      return 1;
    }
    return 0;
  }

  definirValorUo = (nivel) => {
    if (nivel === 3) {
      return this.state.filtrosEscolhidos.aps;
    } else if (nivel === 2) {
      return this.state.filtrosEscolhidos.gex;
    } else if (nivel === 1) {
      return this.state.filtrosEscolhidos.superintendencia;
    }
    return 0;
  }

  defineCodigoOutroParticipante = (parametros) => {
    const novosParametros = parametros;
    if (this.state.papelUsuarioLogado !== 'analista-rgps') {
      novosParametros.outroParticipante = '01000';
    }

    if (this.state.filtrosEscolhidos.participante) {
      novosParametros.codigo = this.state.filtrosEscolhidos.participante;
    } else if (this.state.filtrosEscolhidos.aps) {
      novosParametros.codigo = this.state.filtrosEscolhidos.aps;
    } else if (this.state.filtrosEscolhidos.gex) {
      novosParametros.codigo = this.state.filtrosEscolhidos.gex;
    } else if (this.state.filtrosEscolhidos.superintendencia) {
      novosParametros.codigo = this.state.filtrosEscolhidos.superintendencia;
    }

    return novosParametros;
  }

  converterValoresParaTipoNumerico = (valor) => {
    let retorno = null;
    if (valor) {
      retorno = Number(valor);
    }
    return retorno;
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosEscolhidos).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      let urlRelatorio = null;
      const nivel = this.defineNivelFiltro();
      urlRelatorio = 'relatorios/conflitos-periodos';

      const parametros = {
        tipoParticipacao: this.converterValoresParaTipoNumerico(this.state.filtrosEscolhidos.opcao),
        participante: this.state.filtrosEscolhidos.participante,
        estado: this.converterValoresParaTipoNumerico(this.state.filtrosEscolhidos.estado),
        estadoConflito: this.converterValoresParaTipoNumerico(this.state.filtrosEscolhidos.estadoConflito),
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      };

      if (this.state.filtrosEscolhidos.participanteObservador) {
        parametros.participanteObservador = this.state.filtrosEscolhidos.participanteObservador;
      }

      if (this.isConsultaPorVisao()) {
        if (this.state.papelUsuarioLogado === 'analista-rgps' ||
          this.state.filtrosEscolhidos.participanteObservador === '01000') {
          parametros.nivelUo = nivel;
          parametros.idUo = this.definirValorUo(nivel);
        }
      }

      this.setState({
        urlExportacao: urlRelatorio,
        parametrosExportacao: parametros,
      }, () => this.preparaRequest(urlRelatorio, parametros));
    }
  };

  preparaRequest = (urlRelatorio, parametros) => {
    doPost(
      urlRelatorio,
      parametros,
      this.tratarSucesso(),
      this.tratarErro,
    );
  }

  recuperarTituloPorId = (lista, id) => {
    let retorno = '';
    const index = lista.findIndex(item => (item.value === id));
    if (index !== -1) {
      retorno = lista[index].label;
    }
    return retorno;
  }

  exibirComplementoPorNivelSuperintendencia = () => {
    const nivel = this.defineNivelFiltro();
    let retorno = '';
    let nome = '';
    switch (nivel) {
      case 1:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaSuperintendencias, this.state.filtrosEscolhidos.superintendencia);
        retorno = `SUPERINTENDÊNCIA: ${this.state.filtrosEscolhidos.superintendencia} - ${nome}`;
        break;
      case 2:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaGexs, this.state.filtrosEscolhidos.gex);
        retorno = `GEX: ${this.state.filtrosEscolhidos.gex} - ${nome}`;
        break;
      case 3:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaAps, this.state.filtrosEscolhidos.aps);
        retorno = `APS: ${this.state.filtrosEscolhidos.aps} - ${nome}`;
        break;
      default:
        break;
    }
    return retorno.toUpperCase();
  }

  exibirNomeEstado = estado => (
    (listUtils.getObject(listUtils.tiposEstado, estado).label).toUpperCase()
  );

  handleClickNovoEstadoSuccess = (response) => {
    this.pushNavegacao(response.data.protocolo);
  }

  handleClickNovoEstadoFail = () => {
  }

  pushNavegacao = (protocolo) => {
    this.props.history.push(`/requerimento/aposentadoria/${protocolo}`);
  }

  handleClickDetalhe = (protocolo) => {
    doGet(
      `requerimentos-compensacao-aposentadoria/${protocolo}`,
      this.handleClickNovoEstadoSuccess,
      this.handleClickNovoEstadoFail,
    );
  }

  isConsultaPorVisao = () => {
    let ehVisao = false;
    if ([2, 3].includes(this.state.filtrosEscolhidos.opcao)) {
      ehVisao = true;
    }
    return ehVisao;
  }

  handleSuccessBuscaPeloCnpjLogado = (response) => {
    let nome = '';
    if (response.data) {
      nome = `${response.data.nome} - ${response.data.codigo}`;
      this.setState({
        nomeSolicitante: nome,
      });
    }
  }

  handleErrorBuscaPeloCnpjLogado = () => (
    ''
  );

  buscarParticipantePeloCnpjLogado = () => {
    if (ehPapelObservadorRelatorio(this.state.papelUsuarioLogado) || this.state.papelUsuarioLogado === 'analista-rpps') {
      const usuarioLogado = new User(localStorage.getItem('jwt'));
      const cnpj = usuarioLogado.cnpjDoPapel();
      if (cnpj) {
        doGet(
          `participantes-compensacao/${cnpj}`,
          this.handleSuccessBuscaPeloCnpjLogado,
          this.handleErrorBuscaPeloCnpjLogado,
        );
      }
    } else if (this.state.papelUsuarioLogado === 'analista-rgps') {
      this.setState({
        nomeSolicitante: 'RGPS',
      });
    }
  }

  buscarDestinatario = () => {
    const nivel = this.defineNivelFiltro();
    let retorno = '';
    let nome = '';
    switch (nivel) {
      case 1:
        nome = this.recuperarTituloPorId(this.state.filtrosEscolhidos.listaSuperintendencias, this.state.filtrosEscolhidos.superintendencia);
        retorno = `SUPERINTENDÊNCIA: ${this.state.filtrosEscolhidos.superintendencia} - ${nome}`;
        break;
      case 2:
        nome = this.recuperarTituloPorId(this.state.filtrosEscolhidos.listaGexs, this.state.filtrosEscolhidos.gex);
        retorno = `GEX: ${this.state.filtrosEscolhidos.gex} - ${nome}`;
        break;
      case 3:
        nome = this.recuperarTituloPorId(this.state.filtrosEscolhidos.listaAps, this.state.filtrosEscolhidos.aps);
        retorno = `APS: ${this.state.filtrosEscolhidos.aps} - ${nome}`;
        break;
      case 4:
        if (this.state.filtrosEscolhidos.participante === '01000') {
          nome = 'RGPS';
        } else {
          nome = this.recuperarTituloPorId(this.props.destinatarios, this.state.filtrosEscolhidos.participante);
        }
        retorno = `DESTINATÁRIO: ${this.state.filtrosEscolhidos.participante} - ${nome}`;
        break;
      default:
        break;
    }
    return retorno.toUpperCase();
  }

  exibirNomeSolicitante = () => {
    let retorno = '';
    if (ehPapelObservadorRelatorio(this.state.papelUsuarioLogado)) {
      retorno = `SOLICITANTE: ${this.recuperarTituloPorId(this.props.destinatarios, this.state.filtrosEscolhidos.participanteObservador)} -
      ${this.state.filtrosEscolhidos.participanteObservador}`;
    } else {
      retorno = `SOLICITANTE: ${this.state.nomeSolicitante}`;
    }
    return ` - ${retorno.toUpperCase()}`;
  };

  montarTituloSolicitanteOuDestinatario = (titulo) => {
    let retorno = '';
    if (ehPapelObservadorRelatorio(this.state.papelUsuarioLogado)) {
      const participanteObservadorSelecionado = this.state.filtrosEscolhidos.participanteObservador;
      retorno = `${titulo} ${this.recuperarTituloPorId(this.props.destinatarios, this.state.filtrosEscolhidos.participanteObservador)} - ${participanteObservadorSelecionado}`;
    } else {
      retorno = `${titulo} ${this.state.nomeSolicitante}`;
    }
    return retorno;
  }

  especificarConsultaPorVisao = () => {
    let retorno = '';
    switch (this.state.filtrosEscolhidos.opcao) {
      case 2:
        retorno = this.montarTituloSolicitanteOuDestinatario('SOLICITANTE:');
        break;
      case 3:
        retorno = this.montarTituloSolicitanteOuDestinatario('DESTINATÁRIO:');
        break;
      default:
        break;
    }
    return retorno;
  }

  montarLegendaNomeRelatorioPorFiltroSelecionado = () => {
    let textoFinal = '';
    const titulo = 'conflitos de períodos';
    const dataAtual = `${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`;

    if (this.isConsultaPorVisao()) { // (VISÃO: OPCAO SOLICITANTE OU DESTINATARIO ESCOLHIDA)
      // textoFinal = `${titulo} ${nomeEstado} - ${this.especificarConsultaPorVisao()} ${dataAtual} ${complementoPorNivelSuperintendencia} ${complementoPorTipoDeLista}`;
      textoFinal = `${titulo} ${this.exibirComplementoPorNivelSuperintendencia()} ${dataAtual}`;
    } else {
      // textoFinal = `${titulo} ${nomeEstado} ${this.exibirNomeSolicitante()} ${this.buscarDestinatario()} ${dataAtual} ${complementoPorTipoDeLista}`;
      // textoFinal = `${titulo} - AMBOS - ${dataAtual}`;
      textoFinal = `${titulo} - ${dataAtual}`;
    }
    return textoFinal;
  }

  colunasRelatorio = [
    'CPF',
    'Nome',
    'Matrícula',
    'Solicitante',
    'Destinatário',
    'Estado',
    'Detalhe',
  ]

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    if (tipo === undefined || tipo === null) {
      return '';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  pesquisarColunaJson = (json, coluna) => {
    let retorno = json[coluna];
    if (retorno === undefined) {
      retorno = '';
    }
    return retorno;
  }

  extrairColunasJson = (data) => {
    let objetoLinha = {};
    const dados = data.map((item) => {
      const objSolicitante = `${item[Object.keys(item)[1]]}-${item[Object.keys(item)[0]]}`;
      const objDestinatario = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
      objetoLinha = {
        cpf: this.pesquisarColunaJson(item, 'cpf'),
        nome: this.pesquisarColunaJson(item, 'nome'),
        matricula: this.pesquisarColunaJson(item, 'matricula'),
        solicitante: objSolicitante,
        destinatario: objDestinatario,
        estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
        protocolo: this.pesquisarColunaJson(item, 'protocolo'),
      };
      return objetoLinha;
    });
    return dados;
  }

  montaColuna = tipo => (cell, row) => {
    let valor = cell;
    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'nit') {
      if (Number.isInteger(cell)) {
        valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      } else {
        valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      }
    } else if (tipo === 'botao') {
      valor = (
        <Button
          hint="ir para o requerimento"
          icon="ico-doc-magnifier"
          mini
          onClick={() => this.handleClickDetalhe(row.protocolo)}
        />
      );
    }

    return (
      <React.Fragment>
        {valor}
      </React.Fragment>
    );
  }

  relatorioDataFormatOptions = {
    6: this.montaColuna('botao'),
  }

  tratarSucesso = () => (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }

    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    let dataFormatOptions = {};

    if (response.data !== '') {
      const lista = this.extrairColunasJson(response.data);
      dataFormatOptions = this.relatorioDataFormatOptions;
      const dadosFormatados = this.prepararColunasExportacao(lista);
      this.setState({
        listaResultados: lista,
        listaResultadosFormatados: dadosFormatados,
        colunasRelatorio: this.colunasRelatorio,
        nomeRelatorio: this.montarLegendaNomeRelatorioPorFiltroSelecionado(),
        estadoTabela,
        dataFormatOptions,
      });
    }
  }

  prepararColunasExportacao = (data) => {
    const dados = data.map((item) => {
      const linha = Object.assign({}, item);
      return linha;
    });
    return dados;
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  // FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
  formatarColuna = (cell, tipo) => {
    let valor = cell;

    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'booleano') {
      valor = cell === 1 ? 'S' : 'N';
    }
    return valor.trim();
  }

  defineContainerStyle = () => {
    let width = this.state.colunasRelatorio.length * 130;
    if (width < 1140) {
      width = 1140;
    }
    return {
      width: `${width}px`,
    };
  };

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  render() {
    const options = {
      noDataText: 'Nenhum registro a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    return (
      <DtpContentContainer>
        <FiltroRelatorioConflitoPeriodos
          tipo="Conflitos de períodos"
          filtroModalidade={false}
          handleSearchFilter={this.realizaConsulta}
          papelUsuarioLogado={this.state.papelUsuarioLogado}
          destinatarios={this.props.destinatarios}
          observardorDeMudanca={this.zerarPaginacao}
          nomeFiltro="FiltroRelatorioConflitoPeriodos"
        />
        {this.state.nomeRelatorio !== '' ? (
          <NovoRelatorioConflitoPeriodos
            legend={this.state.nomeRelatorio}
            bordered
            headers={this.state.colunasRelatorio}
            data={this.state.listaResultados}
            options={options}
            pagination
            remote
            dataFormatOptions={this.state.dataFormatOptions}
            landscape
            containerStyle={this.defineContainerStyle()}
            // exportacao={this.state.listaResultadosFormatados}
            fetchInfo={fetchInfo}
            rowAtual={this.state.rowAtual}
            urlExportacao={this.state.urlExportacao}
            parametrosExportacao={this.state.parametrosExportacao}
          />
          ) : null
        }
      </DtpContentContainer>
    );
  }
}

TelaRelatorioConflitoPeriodos.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

TelaRelatorioConflitoPeriodos.defaultProps = {
  destinatarios: [],
};

// eslint-disable-next-line
const mapStateToProps = (state) => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(TelaRelatorioConflitoPeriodos);



// WEBPACK FOOTER //
// ./src/pages/relatorios/TelaRelatorioConflitoPeriodos.jsx